module.exports = __webpack_public_path__ + "slide3.jpg?11603ecf896aab176edb65e06caa68ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide3.jpg
// module id = 320
// module chunks = 0